import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas() {
        let url = `${api}/mensagens`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        let url = `${api}/mensagens/${id}`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterFornecedores() {
        let url = `${api}/mensagens/fornecedores`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    salvarMensagem(mensagem) {
        let url = `${api}/mensagens`
        return axiosJwt.post(url, mensagem)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    enviarMensagem(mensagem) {
        let url = `${api}/mensagens/enviar`
        return axiosJwt.post(url, mensagem)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    lerNaoLerMensagem(mensagemId) {
        let url = `${api}/mensagens/${mensagemId}`
        return axiosJwt.patch(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirMensagem(mensagemId) {
        let url = `${api}/mensagens/${mensagemId}`
        return axiosJwt.delete(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
